"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ramda = require("ramda");

var _joinLimitFeathers = _interopRequireDefault(require("./joinLimitFeathers"));

var _joinOffsetFeathers = _interopRequireDefault(require("./joinOffsetFeathers"));

var _joinFilterFields = _interopRequireDefault(require("./joinFilterFields"));

var _joinOrderFeathers = _interopRequireDefault(require("./joinOrderFeathers"));

var wrapToParams = function wrapToParams(query) {
  return {
    query: query
  };
};

var buildFindParams = function buildFindParams(filter, order, pagination) {
  return (0, _ramda.pipe)((0, _joinLimitFeathers.default)(pagination.rowsPerPage), (0, _joinOffsetFeathers.default)(pagination.rowsPerPage * pagination.page), (0, _joinFilterFields.default)(filter), (0, _joinOrderFeathers.default)(order), wrapToParams)({});
};
/**
 * Vraci slozeny query object.
 *
 * @param {Array<Object>} filter casti filtru
 * @param {{ orderBy: string, orderDirection: 'asc' | 'desc', alternative: string }} order nastaveni razeni
 * @param {{ limit: number, offset: number }} pagination nastaveni paginace
 * @param {{ async: boolean }} options
 *
 * @returns {Object | Promise<Object>}
 */


var queryBuilderFeathers = (0, _ramda.curry)(function (options, filter, order, pagination) {
  var _async$options = (0, _extends2.default)({
    async: false
  }, options),
      isAsync = _async$options.async;

  var findParams = buildFindParams(filter, order, pagination);
  return isAsync ? Promise.resolve(findParams) : findParams;
});
var _default = queryBuilderFeathers;
exports.default = _default;